import React, { useState, useEffect } from 'react';
import { Alert, Button, Col, FormGroup, Row } from 'react-bootstrap';
import { Label } from '../../../components/Label';
import { Options, Select } from '../../../components/Select';
import { CardContent } from '../../../components/CardContent';
import { Title } from '../../../components/Title';
import { FillList, FillPen } from '../../../components/Icons';
import api from '../../../services/api';
import './Style.css';
import { PgrGhe } from '../Ghe';
import HistoricoModal from '../../../components/HistoricoModal';
import AlertMessage from '../../../components/Alert';
import { useLocation, useParams } from 'react-router-dom';
import { Box, Modal, Tooltip, Typography } from '@mui/material';
import { Modal as MaterialModal } from '@mui/material';
import { FillCrown } from '../../../components/Icons';
import { NiveisAcesso } from '../../../constants/niveisAcesso';
import { DateTime } from 'luxon';
import useDriver from '../../../hooks/useDriver';
import { OptionsRevisao, SelectRevisao } from '../../../components/SelectRevisao';

export function PgrRevisao({ idEmpresa, idFdt, documento, externoPgr, externoPcmso }: any) {
    const { revisaoId } = useParams<{ revisaoId: string }>();
    const [emissoes, setEmissoes]: any = useState([]);
    const [selectedEmissao, setSelectedEmissao]: any = useState(null);
    const [revisaoInserida, setRevisaoInserida] = useState(false);
    const [tudoInserido, setTudoInserido] = useState(false);
    const [nivelAcesso, setNivelAcesso] = useState(0);
    const [selectedEmissaoId, setSelectedEmissaoId]: any = useState(null);
    const [selectedRevisaoId, setSelectedRevisaoId]: any = useState(null);
    const [gheDataBanco, setGheDataBanco]: any = useState(null);
    const [isInsertionMode, setIsInsertionMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingRevisao, setEditingRevisao]: any = useState(null);
    const [showHistoricoModal, setShowHistoricoModal] = useState(false);
    const [historicoData, setHistoricoData] = useState([]);
    const [revisoes, setRevisoes] = useState([]);
    const [selectedRevisoesId, setSelectedRevisoesId]: any = useState(null);
    const [docLiberado, setDocLiberado]: any = useState(null);
    const location = useLocation();
    const pathName = location.pathname;
    const routeName = pathName.substring(pathName.lastIndexOf('/') + 1);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [showAccessModal, setShowAccessModal] = useState(false);
    const [enviado, setEnviado] = useState(false);
    const { pgrExterno } = useDriver(location.pathname);
    const [showModalAviso, setShowModalAviso] = useState(false)
    const [diasRestantes, setDiasRestantes] = useState()
    const [mensagemAviso, setMensagemAviso] = useState("")

    //quarentena
    const [quarentenaDataInicialRevisao, setQuarentenaDataInicialRevisao]: any = useState('');
    const [quarentenaDataFinalRevisao, setQuarentenaDataFinalRevisao]: any = useState('');

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    useEffect(() => {
        console.log(revisaoId)
        if (selectedRevisaoId || revisaoId) {
            //quarentena
            api.get(`get-quarentena/pgr_revisao/created_at/${revisaoId ? revisaoId : selectedRevisaoId}`).then((response: any) => {
                setQuarentenaDataInicialRevisao(response.data[0])
            })

            api.get(`get-quarentena/pgr_revisao/expires_at/${revisaoId ? revisaoId : selectedRevisaoId}`).then((response: any) => {
                setQuarentenaDataFinalRevisao(response.data[0])
            })
            /////////////////
            for (let emissao of emissoes) {
                const foundRevisao = emissao.revisoes.find((revisao: any) => revisao.id.toString() === revisaoId);
                if (foundRevisao) {
                    setSelectedEmissaoId(emissao.id.toString());  // Definindo o ID da emissão correspondente
                    setSelectedRevisaoId(revisaoId);  // Definindo o ID da revisão
                    break;  // Sai do loop uma vez que a correspondência é encontrada
                }
            }
        }



    }, [revisaoId, selectedRevisaoId]);

    //quarentena
    let log;
    let tooltipTitleDataInicial: any;

    if (quarentenaDataInicialRevisao) {
        log = JSON.parse(quarentenaDataInicialRevisao.log);
        const valorOriginalFormatado = DateTime.fromISO(log.valor_original).toFormat('dd/MM/yyyy HH:mm:ss');
        const valorAtualFormatado = DateTime.fromISO(log.valor_atual).toFormat('dd/MM/yyyy HH:mm:ss');
        tooltipTitleDataInicial = `Valor original: ${valorOriginalFormatado}, Valor atual: ${valorAtualFormatado}`;
    }

    let logDataFinal;
    let tooltipTitleDataFinal: any;

    if (quarentenaDataFinalRevisao) {
        logDataFinal = JSON.parse(quarentenaDataFinalRevisao.log);
        const valorOriginalFormatado = DateTime.fromISO(logDataFinal.valor_original).toFormat('dd/MM/yyyy HH:mm:ss');
        const valorAtualFormatado = DateTime.fromISO(logDataFinal.valor_atual).toFormat('dd/MM/yyyy HH:mm:ss');
        tooltipTitleDataFinal = `Valor original: ${valorOriginalFormatado}, Valor atual: ${valorAtualFormatado}`;
    }


    useEffect(() => {
        api.get('nivel-acesso').then((response: any) => {
            setNivelAcesso(response.data.nivel)
        })
    }, [])

    useEffect(() => {
        handleSearchRevisaoEnviada()
    }, [selectedRevisaoId, selectedEmissaoId])

    const getExternoBasedOnRoute = () => {
        if (routeName === 'pgr') {
            return externoPgr;
        } else if (routeName === 'pcmso') {
            return externoPcmso;
        }
        return null;
    };

    const externo = getExternoBasedOnRoute();
    console.log(externo)

    const fetchHistorico = async () => {
        try {
            const response = await api.post(`listar-historico/${idFdt}/${selectedRevisaoId}`);
            const responseData = response.data;

            const dadosFiltrados = responseData.historico
                .filter((item: any) => item.revisao.id == selectedRevisaoId)
                .sort((a: any, b: any) => {
                    if (a.funcao.pgrGhe.nome < b.funcao.pgrGhe.nome) return -1;
                    if (a.funcao.pgrGhe.nome > b.funcao.pgrGhe.nome) return 1;
                    return 0;
                });

            setHistoricoData(dadosFiltrados);
            setShowHistoricoModal(true);
        } catch (error) {
            console.error("Erro ao buscar histórico:", error);
        }
    };

    const fetchRevisoesParaCopia = async () => {
        if (idFdt && idEmpresa) {
            try {
                const response = await api.post(`listar-revisoes-para-copia/${idFdt}`, {
                    id_empresa: idEmpresa
                });
                const data = response.data;
                setRevisaoInserida(true);
                setRevisoes(response.data.revisao);
            } catch (error) {
                console.error("Erro ao buscar revisões para cópia:", error);
            }
        }
    };

    async function fetchEmissaoRevisoes(selectedEmissaoIdParam = null, selectedRevisaoIdParam = null) {
        if (idEmpresa && idFdt) {
            try {
                const response = await api.post('listar-pgr', {
                    id_empresa: idEmpresa,
                    id_fdt: idFdt
                });
                setDocLiberado(response.data.emissoes.doc_liberado);

                const emissaoData = response.data.emissoes || [];
                const anoAtual = new Date().getFullYear();
                // const existeEmissaoEsteAno = emissaoData.some((emissao: any) => new Date(emissao.created_at).getFullYear() === anoAtual);

                if (emissaoData.length > 0) {
                    setEmissoes(emissaoData);
                    console.log(emissaoData)

                    const ultimaEmissao = emissaoData[emissaoData.length - 1];
                    setSelectedEmissaoId(ultimaEmissao.id);
                    setSelectedEmissao(ultimaEmissao);

                    if (ultimaEmissao.expires_at) {
                        const dataAtual: any = new Date();
                        const dataExpiracao: any = new Date(ultimaEmissao.expires_at);

                        const diffTime: any = dataExpiracao - dataAtual;
                        const diffDias: any = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                        if (diffDias > 0 && diffDias <= 30) {
                            setDiasRestantes(diffDias);
                            setMensagemAviso(`Faltam ${diffDias} dias para que sua emissão atual expire. Considere adquirir uma nova Revisão Anual Global!`);
                            setShowModalAviso(true);
                        } else if (diffDias <= 0) {
                            setMensagemAviso("A emissão atual expirou. É necessária a compra de uma Revisão Global Anual!");
                            setShowModalAviso(true);
                        }
                    }
                }

                if (selectedEmissaoIdParam) {
                    const emissaoSelecionada = emissaoData.find((emissao: any) => emissao.id === selectedEmissaoIdParam);
                    setSelectedEmissao(emissaoSelecionada);
                    setSelectedEmissaoId(emissaoSelecionada.id);

                    if (selectedRevisaoIdParam) {
                        const revisaoSelecionada = emissaoSelecionada.revisoes.find((revisao: any) => revisao.id === selectedRevisaoIdParam);
                        setSelectedRevisaoId(revisaoSelecionada.id);
                    } else {
                        const ultimaRevisao = emissaoSelecionada.revisoes[emissaoSelecionada.revisoes.length - 1];
                        setSelectedRevisaoId(ultimaRevisao.id);
                    }
                }
            } catch (error) {
                console.error("Erro ao carregar emissões e revisões:", error);
            }
        }
    }

    useEffect(() => {
        fetchRevisoesParaCopia();
    }, [idFdt])

    useEffect(() => {
        fetchEmissaoRevisoes();
    }, [idEmpresa, idFdt, revisaoInserida, tudoInserido]);

    const inserirRevisao = async () => {
        try {
            await api.post('inserir-revisao', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                tipo_documento: routeName
            });
            setRevisaoInserida(true);
        } catch (error) {
            console.error("Erro ao inserir revisão:", error);
        }
    };

    const buscarEmissaoEnviada = async () => {
        try {
            await api.post('buscar-emissao-enviada', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                tipo_documento: routeName
            });
            setRevisaoInserida(true);
        } catch (error) {
            console.error("Erro ao inserir revisão:", error);
        }
    };

    const handleSelectEmissao = (id: any) => {
        const emissaoSelecionada = emissoes.find((emissao: any) => emissao.id === id);
        setSelectedEmissao(emissaoSelecionada);
        setSelectedEmissaoId(emissaoSelecionada.id);

        if (emissaoSelecionada.revisoes && emissaoSelecionada.revisoes.length > 0) {
            const ultimaRevisao = emissaoSelecionada.revisoes[emissaoSelecionada.revisoes.length - 1];
            setSelectedRevisaoId(ultimaRevisao.id);
        }
    };

    const checkExpiredRevisao = () => {
        const emissaoSelecionada = emissoes.find((emissao: any) => emissao.id === selectedEmissaoId);

        const dataExpiracao = new Date(emissaoSelecionada.expires_at);
        const dataAtual = new Date();
        const isVencida = dataExpiracao.getTime() < dataAtual.getTime();

        return isVencida
    }

    const handleSelectRevisao = (id: any) => {
        setSelectedRevisaoId(id);
    };

    const handleSelectRevisoes = (id: any) => {
        setSelectedRevisoesId(id);
    };

    const handleDataInicioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEditingRevisao((prevState: any) => ({
            ...prevState,
            dataInicio: event.target.value,
        }));
    };

    const handleDataValidadeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEditingRevisao((prevState: any) => ({
            ...prevState,
            dataValidade: event.target.value,
        }));
    };

    const handleSaveRevisao = async () => {
        if (!selectedEmissaoId || !selectedRevisaoId) {
            console.error("Emissão ou revisão não selecionada.");
            return;
        }

        const now = new Date();
        now.setHours(0, 0, 0, 0);

        const dataInicio = new Date(editingRevisao.dataInicio);
        dataInicio.setHours(0, 0, 0, 0);

        const dataValidade = new Date(editingRevisao.dataValidade);
        dataValidade.setHours(0, 0, 0, 0);

        const oneYearLater = new Date(dataInicio);
        oneYearLater.setFullYear(dataInicio.getFullYear() + 1);

        if (dataValidade > oneYearLater) {
            console.error("A data de validade excede um ano a partir da data de início.");
            setAlert({
                show: true,
                message: 'A data de validade não pode ser superior a um ano a partir da data de início.',
                variant: 'danger'
            });
            return;
        }

        try {
            await api.post('salvar-data-revisao', {
                id_empresa: idEmpresa,
                id_fdt: idFdt,
                id_emissao: selectedEmissaoId,
                id_revisao: selectedRevisaoId,
                data_inicio: editingRevisao.dataInicio,
                data_validade: editingRevisao.dataValidade
            });

            await fetchEmissaoRevisoes(selectedEmissaoId, selectedRevisaoId);
            exitEditMode();

            setAlert({
                show: true,
                message: 'Revisão alterada com sucesso!',
                variant: 'success'
            });

        } catch (error) {
            console.error("Erro ao enviar dados da revisão:", error);
            setAlert({
                show: true,
                message: 'Erro ao alterar revisão!',
                variant: 'danger'
            });
        }
    };

    // const liberarDocumento = async () => {
    //     if (selectedEmissao && selectedEmissaoId && selectedRevisaoId) {
    //         try {
    //             const response = await api.post('liberar-revisao', {
    //                 id_emissao: selectedEmissaoId,
    //                 id_revisao: selectedRevisaoId,
    //                 id_empresa: idEmpresa,
    //                 id_fdt: idFdt,
    //             });

    //             const currentSelectedEmissaoId = selectedEmissaoId;
    //             const currentSelectedRevisaoId = selectedRevisaoId;

    //             if (currentSelectedRevisaoId === selectedRevisaoId) {
    //                 setSelectedRevisaoId(null);
    //                 await fetchEmissaoRevisoes(currentSelectedEmissaoId, currentSelectedRevisaoId);
    //             }

    //         } catch (error) {
    //             console.error("Erro ao liberar documento:", error);
    //         }
    //     }
    // };

    const toggleInsertionMode = async () => {
        if (checkExpiredRevisao() && nivelAcesso !== NiveisAcesso.ADMIN) {
            setAlert({
                show: true,
                message: 'Não é possível criar uma revisão para uma emissão vencida! ',
                variant: 'danger'
            });
        } else {
            if (await handleSearchProduct() && nivelAcesso !== NiveisAcesso.ADMIN) {
                setShowAccessModal(true);
            }
            else {
                if (!isInsertionMode) {
                    await fetchRevisoesParaCopia();
                }
                setIsInsertionMode(!isInsertionMode);
            }
        }

    };

    const handleSearchProduct = async () => {
        if (idEmpresa !== null && idFdt !== null) {
            try {
                const productResponse = await api.get(`listar-produto-user/${idEmpresa}/${idFdt}`);
                const productData = productResponse.data;

                const produtos = productData.filter((item: { tipo_produto: string; }) => item.tipo_produto === 'Adicional');
                console.log(produtos)

                if (produtos.length > 0) {
                    if (produtos[produtos.length - 1].entregue == 1) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }

            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        }
        return true;
    }

    const handleSearchRevisaoEnviada = async () => {
        if (idEmpresa !== null && idFdt !== null) {
            try {
                const revisaoResponse = await api.post(`listar-revisao-enviada/${selectedRevisaoId ? selectedRevisaoId : selectedEmissaoId}`);
                const revisaoData = revisaoResponse.data;

                setEnviado(revisaoData);

            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        }
        return true;
    }

    const exitEditMode = () => {
        setIsEditMode(false);
        setEditingRevisao(null);
    };

    const enterEditMode = (revisao: any) => {
        setIsInsertionMode(false);
        const dataInicio = revisao.created_at;
        const dataValidade = revisao.expires_at;

        setEditingRevisao({
            ...revisao,
            dataInicio: formatDateToInput(dataInicio),
            dataValidade: formatDateToInput(dataValidade),
        });

        setIsEditMode(true);
    };

    const enterEditModeWithSelectedRevisao = () => {
        const revisao = emissoes.find((emissao: any) => emissao.id === selectedEmissaoId);
        if (revisao) {
            enterEditMode(revisao);
        }
    };

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} às ${date.getHours().toString().padStart(2, '0')}h${date.getMinutes().toString().padStart(2, '0')}`;
        return formattedDate;
    };

    const formatDateToInput = (dateString: string) => {
        const date = new Date(dateString);
        const userTimezoneOffset = date.getTimezoneOffset() * 60000;
        return (new Date(date.getTime() - userTimezoneOffset)).toISOString().split('.')[0];
    };

    const handleSaveNewReview = async () => {
        try {
            const response = await api.post(`listar-revisao/${selectedRevisoesId}/${idEmpresa}`);
            const responseData = response.data;

            const productResponse = await api.get(`listar-produto-user/${idEmpresa}/${idFdt}`);
            const productData = productResponse.data;

            await api.post('atualizar-adicional', productData);

            if (selectedRevisoesId !== 0 && responseData) {
                const dataToAdd = {
                    id_empresa: responseData.revisao[0].id_empresa,
                    id_fdt: responseData.revisao[0].id_fdt,
                    nome: responseData.revisao[0].nome,
                    id_emissao: responseData.revisao[0].id_emissao,
                    doc_liberado: responseData.revisao[0].doc_liberado,
                    idRevisao: selectedRevisoesId
                };



                const addResponse = await api.post(`adicionar-revisao-temporal/${idEmpresa}/${idFdt}`, dataToAdd);
                const addData = addResponse.data;

                const gheResponse = await api.get(`listar-ghe/${selectedRevisoesId}/${idEmpresa}`);
                const gheData = gheResponse.data;

                const gheDataArray = [];

                if (gheData && gheData.length !== 0) {
                    for (const ghe of gheData) {
                        const gheDataToAdd = {
                            id_revisao: addData.id,
                            id_empresa: ghe.id_empresa,
                            id_fdt: ghe.id_fdt,
                            nome: ghe.nome
                        };

                        const gheInsertResponse = await api.post('inserir-ghe', gheDataToAdd);
                        gheDataArray.push(gheInsertResponse.data);
                    }

                    setGheDataBanco(gheDataArray);

                    const functionResponse = await api.get(`listar-funcao/${selectedRevisoesId}/${idEmpresa}`);
                    const functionData = functionResponse.data;

                    if (functionData && functionData.length !== 0) {
                        const functionDataToAdd: any[] = [];

                        for (const item of functionData) {
                            functionDataToAdd.push({
                                id_funcao: item.id,
                                id_base_funcao: item.id_base_funcao,
                                id_ghe: item.id_ghe,
                                id_fdt: item.id_fdt,
                                id_revisao: addData.id,
                                descricao: item.descricao,
                                cbo: item.cbo,
                                nome: item.nome,
                                num_tra_masc: item.num_tra_masc,
                                num_tra_fem: item.num_tra_fem,
                                id_empresa: idEmpresa,
                                ghesInseridos: gheDataArray,
                                idRevisao: selectedRevisoesId
                            });
                        }

                        await api.post('inserir-funcao-copiada', functionDataToAdd);
                    }

                    fetchEmissaoRevisoes();
                    setAlert({
                        show: true,
                        message: 'Revisão Inserida!',
                        variant: 'success'
                    });

                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);


                } else {
                    console.log('GHE is null');
                }
            } else if (selectedRevisoesId === 0) {
                const dataToAdd = {
                    id_empresa: idEmpresa,
                    id_fdt: idFdt,
                    id_emissao: selectedEmissaoId,
                    idRevisao: selectedRevisoesId
                };

                await api.post(`adicionar-revisao/${idEmpresa}/${idFdt}`, dataToAdd);
            }

        } catch (error) {
            console.error('Erro na execução:', error);
        }
    };

    const handleDeleteConfirm = async () => {
        await fetchEmissaoRevisoes();

        if (emissoes.length > 0) {
            const ultimaEmissao = emissoes[emissoes.length - 1];
            setSelectedEmissao(ultimaEmissao);
            setSelectedEmissaoId(ultimaEmissao.id);

            if (ultimaEmissao.revisoes && ultimaEmissao.revisoes.length > 0) {
                const ultimaRevisao = ultimaEmissao.revisoes[ultimaEmissao.revisoes.length - 1];
                setSelectedRevisaoId(ultimaRevisao.id);
            } else {
                setSelectedRevisaoId(null);
            }
        } else {
            setSelectedEmissao(null);
            setSelectedEmissaoId(null);
            setSelectedRevisaoId(null);
        }

        setIsEditMode(false);
        setIsInsertionMode(false);
    };

    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const handleCloseAccessModal = () => {
        setShowAccessModal(false);
    };

    return (
        <div>
            {isInsertionMode ? (
                <div id={!pgrExterno ? '' : 'pgrStep2'}>
                    <CardContent>
                        <Title text="Revisão" />
                        <Row className='my-4'>
                            <Col md={6}>
                                <FormGroup>
                                    <Label title="INSIRA UMA NOVA REVISÃO BASEADA EM UMA EXISTENTE" htmlFor="selectRevisao" />
                                    <Select id="selectRevisao" onSelect={handleSelectRevisoes}>
                                        {revisoes && revisoes.map((revisao: any) => (
                                            <Options
                                                key={revisao.id}
                                                value={revisao.id}
                                                name={'Basear-se na ' + revisao.nome + ' em ' + formatDate(revisao.created_at)}
                                                selected={revisaoId ? revisaoId == revisao.id : revisao.id == selectedRevisaoId}
                                            />
                                        ))}
                                    </Select>
                                </FormGroup>
                            </Col>
                            {documento === 'PGR' && (
                                <Col md={6} className='d-flex align-items-end justify-content-start '>
                                    <Button className='btn-main' style={{ margin: '5px' }} onClick={handleSaveNewReview}>Inserir</Button>
                                    <Button variant="secondary" style={{ margin: '5px' }} onClick={toggleInsertionMode}>Cancelar</Button>
                                </Col>
                            )}
                        </Row>
                    </CardContent>
                </div>
            ) : (
                <div>
                    {isEditMode ? (
                        <CardContent>
                            <Title text="Revisão" />
                            <Row className='my-4'>
                                <Col md={4} >
                                    <FormGroup className='form-group-dsg'>
                                        <Label htmlFor='' title="ALTERAR DATA DE INÍCIO PARA ESTA REVISÃO" />
                                        <Tooltip title={quarentenaDataInicialRevisao ? tooltipTitleDataInicial : ''} placement="top">
                                            <div className='dataInput'>
                                                <input
                                                    type="datetime-local"
                                                    value={editingRevisao.dataInicio ? new Date(editingRevisao.dataInicio).toISOString().slice(0, 16) : ''}
                                                    onChange={handleDataInicioChange}
                                                    className={quarentenaDataInicialRevisao ? 'dataInput quarentena-error' : 'dataInput'}
                                                />
                                            </div>
                                        </Tooltip>
                                    </FormGroup>
                                </Col>
                                <Col md={4} >
                                    <FormGroup className='form-group-dsg'>
                                        <Label htmlFor='' title="ALTERAR DATA DE VALIDADE PARA ESTA REVISÃO" />
                                        <Tooltip title={quarentenaDataFinalRevisao ? tooltipTitleDataFinal : ''} placement="top">
                                            <div className='dataInput'>
                                                <input
                                                    type="datetime-local"
                                                    value={editingRevisao.dataValidade ? new Date(editingRevisao.dataValidade).toISOString().slice(0, 16) : ''}
                                                    className={quarentenaDataFinalRevisao ? 'dataInput quarentena-error' : 'dataInput'}
                                                    onChange={handleDataValidadeChange}
                                                />
                                            </div>
                                        </Tooltip>
                                    </FormGroup>
                                </Col>
                                {documento === 'PGR' && (
                                    <Col md={4} className='d-flex align-items-end justify-content-start '>
                                        <Button className='btn-main' style={{ margin: '5px' }} onClick={handleSaveRevisao}>Salvar</Button>
                                        <Button variant="secondary" style={{ margin: '5px' }} onClick={exitEditMode}>Cancelar</Button>
                                    </Col>
                                )}
                            </Row>
                        </CardContent>
                    ) : (
                        <div id={!pgrExterno ? '' : 'pgrStep2'}>
                            <CardContent>
                                <Row>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <Title text="Emissão" />
                                        <Button
                                            style={{
                                                width: '40px',
                                                borderRadius: '20px',
                                            }}
                                            onClick={() => setShowHelpModal(true)}>
                                            ?
                                        </Button>
                                    </Box>
                                    <p style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '0.2%' }}>Ajuda</p>
                                </Row>
                                <Row className='my-4'>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label title="EMISSÃO" htmlFor="rev" />

                                            <SelectRevisao width="100%" id="emissoes" onSelect={handleSelectEmissao}>
                                                {selectedEmissaoId && emissoes && emissoes.map((emissao: any) => {
                                                    const dataExpiracao = new Date(emissao.expires_at);
                                                    const dataAtual = new Date();
                                                    const isVencida = dataExpiracao.getTime() < dataAtual.getTime();

                                                    return (
                                                        <OptionsRevisao
                                                            key={emissao.id}
                                                            value={emissao.id}
                                                            name={(emissao.rev !== null && emissao.rev !== undefined && emissao.rev !== '')
                                                                ? `${emissao.rev} (${emissao.nome} a partir de ${formatDate(emissao.created_at)})`
                                                                : `${emissao.nome} a partir de ${formatDate(emissao.created_at)}`
                                                            }
                                                            selected={emissao.id === selectedEmissaoId}
                                                            color={isVencida ? 'red' : 'black'}
                                                            textDecoration={isVencida ? 'line-through' : 'none'}
                                                        />
                                                    );
                                                })}
                                            </SelectRevisao>


                                        </FormGroup>
                                    </Col>
                                    {nivelAcesso !== NiveisAcesso.ADMIN ? (
                                        selectedRevisaoId && selectedEmissao.revisoes.length > 1 && (
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label title="REVISÃO" htmlFor="rev" />
                                                    <Select width="100%" id='revisoes' onSelect={handleSelectRevisao}>
                                                        {selectedRevisaoId && selectedEmissao && selectedEmissao.revisoes && selectedEmissao.revisoes.map((revisao: any) => (
                                                            <Options
                                                                key={revisao.id}
                                                                value={revisao.id}
                                                                name={
                                                                    (revisao.rev !== null && revisao.rev !== undefined && revisao.rev !== '')
                                                                        ? `${revisao.rev} (${revisao.nome} em ${formatDate(revisao.created_at)})`
                                                                        : `${revisao.nome} em ${formatDate(revisao.created_at)}`
                                                                }
                                                                selected={revisao.id === selectedRevisaoId}
                                                                color={revisao.doc_liberado == true ? 'rgba(51, 65, 92, 1)' : 'rgba(51, 65, 92, 1)'}
                                                            />
                                                        ))}
                                                    </Select>
                                                </FormGroup>
                                            </Col>
                                        )
                                    ) : (
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label title="REVISÃO" htmlFor="rev" />

                                                <Select width="100%" id='revisoes' onSelect={handleSelectRevisao}>
                                                    {selectedRevisaoId && selectedEmissao.revisoes.map((revisao: any) => (
                                                        <Options
                                                            key={revisao.id}
                                                            value={revisao.id}
                                                            name={
                                                                (revisao.rev !== null && revisao.rev !== undefined && revisao.rev !== '')
                                                                    ? `${revisao.rev} (${revisao.nome} em ${formatDate(revisao.created_at)})`
                                                                    : `${revisao.nome} em ${formatDate(revisao.created_at)}`
                                                            }
                                                            selected={revisao.id === selectedRevisaoId}
                                                            color={revisao.doc_liberado == true ? 'rgba(51, 65, 92, 1)' : 'rgba(51, 65, 92, 1)'}
                                                        />
                                                    ))}
                                                </Select>

                                            </FormGroup>
                                        </Col>
                                    )}
                                </Row>
                                <Row className='my-4'>
                                    <Col xs={12} lg={6} className='d-grid d-sm-flex justify-content-md-start crud-revisao mt-4'>
                                        {selectedRevisaoId && selectedEmissao.revisoes && selectedEmissao.revisoes.map((revisao: any) => {
                                            if (revisao.id === selectedRevisaoId) {
                                                if (nivelAcesso == NiveisAcesso.ADMIN) {
                                                    return (
                                                        <>
                                                            <Button className='btn-main' onClick={toggleInsertionMode}>Revisão</Button>
                                                            <>
                                                                <Tooltip title={quarentenaDataFinalRevisao ? 'Data final alterada' : quarentenaDataInicialRevisao ? 'Data inicial alterada' : ''} placement="top">
                                                                    <Button variant="primary" onClick={enterEditModeWithSelectedRevisao} className={quarentenaDataInicialRevisao ? 'quarentena-error' : ''}>
                                                                        Alterar Data
                                                                    </Button>
                                                                </Tooltip>
                                                                {/* {emissoes.length > 1 && (
                                                                    <DeleteModal
                                                                        endpoint='excluir-revisao'
                                                                        onConfirm={handleDeleteConfirm}
                                                                        requestBody={{ id_fdt: idFdt, id_empresa: idEmpresa, id_emissao: selectedEmissaoId, id_revisao: selectedRevisaoId }} />
                                                                )} */}
                                                            </>
                                                        </>
                                                    )
                                                } else if (revisaoInserida) {
                                                    return (
                                                        <>
                                                            {(externo == '1' || enviado == true) && (
                                                                <Button className={`${externo == '1' ? 'blinking-button' : ''}`} onClick={toggleInsertionMode}>Revisão</Button>
                                                            )}
                                                        </>
                                                    )
                                                }
                                            }
                                            return null;
                                        })}

                                    </Col>
                                    <Col xs={12} lg={6} className='d-grid d-sm-flex justify-content-sm-start justify-content-lg-end crud-revisao mt-4'>
                                        <Button variant="primary" onClick={fetchHistorico}>
                                            <FillList />&nbsp;
                                            Histórico
                                        </Button>

                                        <HistoricoModal
                                            show={showHistoricoModal}
                                            onHide={() => setShowHistoricoModal(false)}
                                            historico={historicoData}
                                        />
                                    </Col>
                                </Row>
                            </CardContent>
                        </div>
                    )}
                </div>
            )}
            {idFdt && idEmpresa && selectedRevisaoId ? (
                <PgrGhe idFdt={idFdt} idEmpresa={idEmpresa} idRevisao={selectedRevisaoId} selectedEmissaoId={selectedEmissaoId} documento={documento} externoPgr={externoPgr} externoPcmso={externoPcmso} enviado={enviado} />
            ) : (
                <div></div>
            )}
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
            <MaterialModal
                open={showHelpModal}
                onClose={handleCloseHelpModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'block',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '700px',
                    maxWidth: '90%',
                    maxHeight: '80%'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <h4>AJUDA</h4>
                        <p>
                            <b>Emissão / Revisão :</b>
                        </p>
                        <p>
                            <b>Emissão Original:</b> A emissão representa a data de criação do documento e marca o início de sua validade.
                        </p>
                        <p>
                            <b>Revisão:</b> A revisão indica a data em que foram feitas novas alterações no documento pelo usuário.
                            Este só poderá adicionar uma revisão, modificar a data ou excluí-la após ter enviado o documento para assinatura ao menos uma vez.
                        </p>
                        <p>
                            <b>Histórico:</b> O histórico mostra todas as revisões cadastradas e as funções que estão vinculadas a cada uma delas.
                        </p>
                    </Box>
                </Box>
            </MaterialModal>
            <Modal
                open={showAccessModal}
                onClose={handleCloseAccessModal}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '400px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>Comprar Adicional</h2>
                    <p style={{ textAlign: 'center' }}>Para adicionar uma nova revisão ao seu documento, será necessário comprar um adicional!</p>
                    <Button variant="contained" color="primary" style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }} href={`/planos?empresa=${idEmpresa}&fdt=${idFdt}`}>
                        Comprar
                    </Button>
                </Box>
            </Modal>

            <Modal
                open={showModalAviso}
                onClose={() => setShowModalAviso(false)}
                style={{ backdropFilter: 'blur(10px)' }}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '500px'
                }}>
                    <FillCrown />
                    <h2 style={{ color: '#333', marginBottom: '20px' }}>
                        Emissão atual
                    </h2>
                    <p style={{ textAlign: 'center' }}>{mensagemAviso}</p>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }}
                        href={`/planos?empresa=${idEmpresa}&fdt=${idFdt}`}
                    >
                        Clique aqui para adquirir uma nova!
                    </Button>
                </Box>
            </Modal>
        </div>
    );
}
